(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fb-business-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fb-business-form')) {
  customElements.define('fb-business-form', class extends HTMLElement {
    connectedCallback() {
      let attempts = 0;
      const connect = () => {
        const host = this.closest('.fb-biz-form')?.querySelector('shopify-forms-embed');
        const root = host?.shadowRoot;
        if (!root) return false;
        if (!root.querySelector('[data-fb-business-style]')) {
          const style = document.createElement('style');
          style.dataset.fbBusinessStyle = '';
          style.textContent = this.querySelector('template').content.textContent;
          root.append(style);
        }
        const enhance = () => {
          const form = root.querySelector('form[data-testid="form"]');
          if (!form) return;
          const addHeading = (field, kind, title, number) => {
            const target = form.querySelector(field)?.closest('form>div');
            if (!target || form.querySelector('.fb-form-group-' + kind)) return;
            const heading = document.createElement('h3');
            heading.className = 'fb-form-group fb-form-group-' + kind;
            const label = document.createElement('span');
            label.textContent = number + '  ' + title;
            heading.append(label);
            if (kind === 'occasion') {
              const note = document.createElement('small'); note.textContent = this.dataset.required; heading.append(note);
            }
            target.before(heading);
          };
          addHeading('[id="custom#occasion-selector-label"]', 'occasion', this.dataset.occasion, '01');
          addHeading('[data-testid="field-first_name"]', 'details', this.dataset.details, '02');
          const textarea = form.querySelector('textarea[name="custom#your_ideas"]');
          if (textarea) { textarea.id = 'custom#your_ideas'; textarea.setAttribute('aria-labelledby', 'label-custom#your_ideas'); }
          for (const id of ['label-first_name','label-email','label-custom#approximate_quantity','label-custom#your_ideas','custom#occasion-selector-label']) {
            const label = root.getElementById(id);
            if (label && !label.querySelector('[data-fb-required]')) { const star = document.createElement('span'); star.dataset.fbRequired=''; star.textContent=' *'; label.append(star); }
          }

        };
        enhance();
        this.observer = new MutationObserver(enhance);
        this.observer.observe(root,{childList:true,subtree:true});
        return true;
      };
      if (!connect()) this.timer = setInterval(() => { if (connect() || ++attempts >= 120) clearInterval(this.timer); },250);
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
